module.exports = __webpack_public_path__ + "img/1538311918.c52337a5.jpg";